import { ContentKind } from "@/lib/qr/types";

// QR Code Generator State
export interface QRState {
  // Content
  kind: ContentKind['kind'];
  content: any;
  
  // Display options
  showPreview: boolean;
  showDynamic: boolean;
  
  // Encoding options
  ecl: 'L' | 'M' | 'Q' | 'H';
  width: number;
  marginModules: number;
  colorDark: string;
  colorLight: string;
  svg: boolean;
  
  // Dynamic QR options
  dynamicSlug: string;
  dynamicUrl: string;
  dynamicExpiresAt: string;
  dynamicMaxScans: number;
  dynamicPassword: string;
}

export const INITIAL_STATE: QRState = {
  kind: 'url',
  content: { url: '' },
  showPreview: true,
  showDynamic: false,
  ecl: 'M',
  width: 512,
  marginModules: 4,
  colorDark: '#000000',
  colorLight: '#ffffff',
  svg: false,
  dynamicSlug: '',
  dynamicUrl: '',
  dynamicExpiresAt: '',
  dynamicMaxScans: 0,
  dynamicPassword: '',
};
